import { myResourceTypeApi } from 'v5/api/resource-types/resource-types.api.connected';
import { myV1ActionEvent } from 'v4/migration/actionAsEventMiddleware.connected';
import { queryClient } from 'v4/migration/queryClientSingleton';
import { myErrorService } from 'v5/services/front/ErrorService/ErrorService.connected';
import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';
import { myMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService.connected';
import { myEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService.connected';
import { myResourceTypeBindingsService } from 'v5/services/internal/ResourceTypeBindingsService/ResourceTypeBindingsService.connected';
import { createResourceTypeAdminService } from './ResourceTypeAdminService.impl';

export const myResourceTypeAdminService = createResourceTypeAdminService({
  api: myResourceTypeApi,
  queryClient,
  resourceTypeBindingsService: myResourceTypeBindingsService,
  v1Event: myV1ActionEvent,
  services: {
    errorService: myErrorService,
    appScopeService: myAppScopeService,
    enterpriseService: myEnterpriseService,
    metastructureMappingService: myMetastructureMappingService
  }
});
